import { FC, useMemo } from "react";
import type { CategoryChartOptions } from "@ortex-charts/react";
import { CategoryBarChart } from "@/components/ortex-charts/Viz";
import { ReactionPoint } from "./helpers";
import styles from "./EventPageRevamp.module.scss";

interface ReactionHistoryChartProps {
    occurrences: ReactionPoint[] | null | undefined;
}

/**
 * Column chart of the next-day % price reaction per occurrence of an event
 * type. Columns are green for a positive reaction and red for a negative one
 * (the theme's up and down colours). Null reactions are skipped, and an empty
 * state is shown when there are no plottable points.
 */
const ReactionHistoryChart: FC<ReactionHistoryChartProps> = ({ occurrences }) => {
    const points = useMemo(() => (occurrences ?? []).filter((o) => o && o.reaction != null), [occurrences]);

    const options = useMemo<Partial<CategoryChartOptions>>(
        () => ({
            categories: points.map((o) => `${o.label}`),
            series: [{ key: "reaction", title: "Next-day reaction", data: points.map((o) => o.reaction as number) }],
            colorBySign: true,
            legend: false,
            barPadding: 0.15,
            valueAxis: { position: "left", visible: true, gridlines: true, format: { type: "percent", precision: 2, sign: true } },
            categoryAxis: { visible: true, maxLabelWidth: 90 },
        }),
        [points]
    );

    if (points.length === 0) return <div className={styles.empty}>No reaction history for this event type.</div>;

    return (
        <div className={styles.ercChart}>
            <CategoryBarChart options={options} />
        </div>
    );
};

export default ReactionHistoryChart;
